import { Link, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../api/client";
import { useUser } from "../auth/useUser";
import { Header } from "../components/Header";

export function ProductDetail() {
  const { uid = "", pid = "" } = useParams();
  const { data: me } = useUser();

  const treeQ = useQuery({
    queryKey: ["admin", "tree", uid, pid],
    queryFn: async () => {
      const { data, error } = await apiClient.GET(
        "/api/v1/admin/users/{uid}/products/{pid}/tree",
        { params: { path: { uid, pid } } },
      );
      if (error) throw error;
      return data;
    },
  });

  const runsQ = useQuery({
    queryKey: ["admin", "runs", uid, pid],
    queryFn: async () => {
      const { data, error } = await apiClient.GET(
        "/api/v1/admin/users/{uid}/products/{pid}/runs",
        { params: { path: { uid, pid } } },
      );
      if (error) throw error;
      return data as { runs?: Array<{ run_id?: string; started_at?: string; status?: string }> };
    },
  });

  if (!me) return null;
  return (
    <div className="min-h-screen flex flex-col">
      <Header user={me} />
      <main className="flex-1 max-w-6xl mx-auto w-full px-4 sm:px-8 py-10">
        <Link to={`/users/${uid}`} className="font-mono text-[11px] text-ink-400 hover:text-ink-100">
          ← User
        </Link>
        <h1 className="mt-4 text-display font-medium text-ink-50 tracking-tightest mb-2">
          Product detail
        </h1>
        <p className="font-mono text-[11px] text-ink-400 mb-6">
          {uid} / {pid}
        </p>

        <section className="mb-10">
          <h2 className="font-mono text-[10px] uppercase tracking-widest text-ink-400 mb-3">
            Tree
          </h2>
          {treeQ.isLoading && <p className="text-sm text-ink-400">loading…</p>}
          {treeQ.error && (
            <p className="text-sm text-rose-300">
              Failed: {(treeQ.error as Error).message}
            </p>
          )}
          {treeQ.data && (
            <pre className="text-[11px] font-mono bg-ink-900 border border-ink-800 rounded p-3 overflow-auto max-h-[60vh]">
              {JSON.stringify(treeQ.data, null, 2)}
            </pre>
          )}
        </section>

        <section>
          <h2 className="font-mono text-[10px] uppercase tracking-widest text-ink-400 mb-3">
            Runs ({runsQ.data?.runs?.length ?? 0})
          </h2>
          <ul className="space-y-1.5 text-sm">
            {(runsQ.data?.runs ?? []).map((r) => (
              <li key={r.run_id}>
                <Link
                  to={`/users/${uid}/products/${pid}/runs/${r.run_id}`}
                  className="hover:text-accent"
                >
                  <span className="font-mono text-[11px] text-ink-400 mr-3">
                    {r.run_id?.slice(0, 12)}…
                  </span>
                  {r.status} · {r.started_at}
                </Link>
              </li>
            ))}
          </ul>
        </section>
      </main>
    </div>
  );
}
